import { CloseOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { DefectReportHistory } from 'business/quality-control/pages/defect-report-history/components/defect-report-table';
import { CapSidebar } from 'ui/sidebar';

import { DefectReportDetailsDefect } from './components/details-defect';
import { DefectReportDetailsHeader } from './components/details-header';
import { DefectReportDetailsRepair } from './components/details-repair';

interface DefectReportDetailsDrawerProps {
  reportId: string | null;
  reports: DefectReportHistory[];
  open: boolean;
  mobile: boolean;
  setSelectedReport: (report: DefectReportHistory) => void;
  onClose: () => void;
  afterOpenChange: (open: boolean) => void;
}

export const DefectReportDetailsDrawer = ({
  reportId,
  reports,
  open,
  mobile,
  setSelectedReport,
  onClose,
  afterOpenChange,
}: DefectReportDetailsDrawerProps) => {
  const { t } = useTranslation();

  const report = reports.find((r) => r.id === reportId);
  const reportIndex = reports.findIndex((r) => r.id === reportId);
  const nextReport = reports[reportIndex + 1];
  const previousReport = reports[reportIndex - 1];

  return (
    <CapSidebar
      title={t('qualityControl.defectReportHistory.drawer.title')}
      onClose={onClose}
      afterOpenChange={afterOpenChange}
      open={open}
      closable={false}
      forceRender
      placement={mobile ? 'bottom' : 'right'}
      width={700}
      extra={<Button type="text" icon={<CloseOutlined />} onClick={onClose} />}
    >
      <Flex gap={24} vertical>
        {report ? (
          <>
            <DefectReportDetailsHeader
              report={report}
              nextReport={nextReport}
              previousReport={previousReport}
              setSelectedReport={setSelectedReport}
            />
            <DefectReportDetailsDefect report={report} />
          </>
        ) : null}

        {report?.repairId ? (
          <DefectReportDetailsRepair report={report} />
        ) : null}
      </Flex>
    </CapSidebar>
  );
};
